export default __webpack_public_path__ + "static/media/整机微站-lite.cc9e4cde.png";